import { createSlice } from "@reduxjs/toolkit";
const editFlightShopData = [];
const editFlightShopSlice = createSlice({
  name: "editFlightShop",
  initialState: {
    editFlightShopData,
  },
  reducers: {
    reSetEditFlightShopData(state, action){
      state.editFlightShopData = editFlightShopData
    },
    setEditFlightShopData(state, action) {
      state.editFlightShopData = action.payload;
    },
  },
});

export const { setEditFlightShopData,reSetEditFlightShopData } = editFlightShopSlice.actions;

export default editFlightShopSlice.reducer;
